import React, {Fragment} from "react";
import {AOperation} from "../../../models/operations/AOperation";
import {IonList} from "@ionic/react";
import ValidationItemService from "../../../services/ValidationItemService";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 18/05/2022
 * @last_update 18/05/2022
 **/
class DisplayOperationForValidation extends React.Component<{
    operation: AOperation
}> {

    render() {

        return (

            <IonList>
                {
                    ValidationItemService.generatesValidationItemsAccordingToOperation(this.props.operation).map((item, index) => (
                        <Fragment key={index}>
                            {item}
                        </Fragment>
                    ))
                }
            </IonList>

        );

    };

}

export default DisplayOperationForValidation;
